import { configureStore } from '@reduxjs/toolkit';
import patientsReducer from './slice/patientSlice';

export const store = configureStore({
    reducer: {
        patients: patientsReducer
    },
});
